/* eslint-disable */
const languages = [
  "en-us",
  "en",
  "de",
  "fr",
  "es",
  "it",
  "pt",
  "ru",
  "zh",
  "id",
  "bs",
  "ca",
  "cs",
  "da",
  "es-co",
  "es-mx",
  "es-ar",
  "gl",
  "hr",
  "sw",
  "lv",
  "lt",
  "hu",
  "ms",
  "nl",
  "nb",
  "pl",
  "pt-pt",
  "ro",
  "sq",
  "sl",
  "sk",
  "sr",
  "fi",
  "sv",
  "tl",
  "vi",
  "tr",
  "el",
  "bg",
  "uk",
  "he",
  "ar",
  "hi",
  "th",
  "zh-Hant",
  "ja",
  "ko"
] as const;
export default languages;
export type SupportedLanguage = typeof languages[number];
